import { defineStore } from "pinia";

export const useCustomerNotesStore = defineStore("customerNotes", {
  state: () => ({
    customerNotes: {}
  }),

  getters: {
    getCustomerNotesValues(state) {
      return state.customerNotes;
    },
    getCustomerNotesHiddenInputs() {
      const data = {};
      Object.keys(this.customerNotes).map(el => {
        data["print_options[customer_notes][" + el + "]"] =
          this.customerNotes[el];
      });
      return data;
    }
  },

  actions: {
    setInitialCustomerNotes(payload) {
      const customerNotes = {};
      payload.map(function (index) {
        customerNotes[index] = "";
      });
      this.customerNotes = customerNotes;
    }
  }
});
